import React from 'react';
import PageHeader from '../../components/pageheader/PageHeader';
import Social from '../../components/social/Social';
import Button from '../../components/button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import HelmetData from '../../components/helmet/HelmetData';

import "./Contact.css";

export default function Contact() {
  return (
    <>
      <HelmetData
        title="Contact"
        descripton="Get in touch and let's get making some awesome games!"
        canonicalLink="https://www.nabilshelim/#/contact"
      />
      <PageHeader title="Contact" icon={faPhone} />
      <div id="Contact" className="contact-intro">
        {/* Social Handles */}
        <div className="contact-social">
          <h2>Get in touch!</h2>
          <br />
          <p>
          Whether you're looking to collaborate on a game project, need a reliable programmer to bring your idea to life, or just want to connect, I'm always open to hearing from you.
          </p>
          <br />
          <a className='contact-email' target="_blank" href="mailto:nabilshelim@gmail.com"> <FontAwesomeIcon icon={faEnvelope} /> nabilshelim@gmail.com</a>
          <Social vertical />
          <br />
          <p>Let’s get in touch and create something great.</p>
        </div>

        {/* Contact form */}
        <div className="card contact-form">
          <h2>Leave a quick message!</h2>
          <form name="Contact" method="post">
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="form-name" value="Contact" />
            <div className="contact-form-control">
              <input type="text" name="name" placeholder="Your Name" required />
            </div>
            <div className="contact-form-control">
              <input type="email" name="email" placeholder="example@gmail.com" required />
            </div>
            <div className="contact-form-control">
              <textarea name="message" placeholder="Your Message!" cols="30" rows="6" />
            </div>
            <Button wide type="submit">Send <FontAwesomeIcon icon={faPaperPlane} /></Button>
          </form>
        </div>
      </div>
    </>
  )
}
